// extracted by mini-css-extract-plugin
export default {"simpleQuestionText":"RadioButtonInput_simpleQuestionText__CXEET","errorText":"RadioButtonInput_errorText__sWAl1"};